import { APIEndpoints } from "utils/APIEndpoints";
import labels from "utils/LocalizedStrings";
import sanitize from "utils/SanitizeHtml";

const SectionFooter = ({ page }) => {
  const footerData = labels?.[page]?.footer;

  if (footerData) {
    return (
      <section className="sectionFooter">
        <div className="footerLogo">
          <img
            src={APIEndpoints.images(
              localStorage.getItem("tenant"),
              "footer-logo.svg"
            )}
            alt="Guest"
          />
        </div>
        {footerData.map((e, index) => {
          if (typeof e == "string") {
            return <p key={index} dangerouslySetInnerHTML={sanitize(e)}></p>;
          } else {
            return (
              <p className="box" key={e}>
                {e.map((listItem) => (
                  <span key={listItem}> &bull; {listItem}</span>
                ))}
              </p>
            );
          }
        })}
      </section>
    );
  } else {
    return <>Footer Data Not Found</>;
  }
};

export default SectionFooter;
